import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchProducts = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
  return axiosInstance.get(EndPoints.PRODUCT.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter
      // total_count:totalItems
    }
  });
}

export const fetchProduct = (payload) => {
  return axiosInstance.get(EndPoints.PRODUCT.PRODUCT_LIST_BY_ID + `/${payload}`);
}

export const createProduct = (payload) => {
  return axiosInstance.post(EndPoints.PRODUCT.CREATE, payload)
}

export const updateProduct = (payload) => {
  return axiosInstance.put(EndPoints.PRODUCT.UPDATE, payload)
}


export const deleteProduct = (payload) => {
  const url = EndPoints.PRODUCT.DELETE + `/${payload}`
  return axiosInstance.delete(url)
}

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.PRODUCT.DOWNLOAD_CSV, {
    responseType: 'blob'
  });
}
